import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { useAppState } from "../../../context/StateContext";
import useOnBoardingContext from "../../../hooks/useOnBoardingContext";
import { Company } from "../../../models/company";
import { FormCompany } from "../../../pages/private/Shared/Settings/Company/FormCompany";
import CompanyService from "../../../services/company.service";

interface CompanyFormProps {
  isSubmitted: boolean;
}

const CompanyForm: React.FC<CompanyFormProps> = ({ isSubmitted }) => {
  const { company, handleSetCompany, errors, handleValidate } = useOnBoardingContext();
  const { currentUser } = useAppState();
  const { t: translate } = useTranslation();

  useEffect(() => {
    if (isSubmitted) handleValidate(company);
  }, [isSubmitted, company]);

  useQuery(
    ["company.get"],
    () =>
      CompanyService.getById(currentUser!.companyId, {
        include: JSON.stringify([
          { association: "location" },
          { association: "logo", include: [{ association: "resizes" }] },
          { association: "icon" },
        ]),
      }),
    {
      enabled: !!currentUser!.companyId,
      onSuccess: (response) => {
        if (response && response.data && response.data.id) {
          const locationId = response.data.location?.id
            ? Number(response.data.location.id)
            : response.data.locationId;

          const companyData: Company = {
            ...response.data,
            locationId,
          };

          handleSetCompany(companyData);
        }
      },
    }
  );

  return (
    <FormCompany
      isOnBoardingPage
      companyInformation={company}
      update={(payload: Company) => handleSetCompany(payload)}
      errors={errors}
      loading={false}
      isUpdating={false}
    />
  );
};

export default CompanyForm;
